import axios from "axios";
import axiosRetry from "axios-retry";
import { errorNotifier } from "./interceptors";

const AccountApi = axios.create({
  baseURL: `${process.env.VUE_APP_SERVER_BASE}/api`,
  withCredentials: true,
  crossDomain: true,
  insecureHTTPParser: true,
  timeout: 15000,
});

export const SafeAccountApi = axios.create({
  baseURL: `${process.env.VUE_APP_SERVER_BASE}/api`,
  withCredentials: true,
  crossDomain: true,
  insecureHTTPParser: true,
  timeout: 15000,
});

axiosRetry(AccountApi, {
  retryDelay: axiosRetry.exponentialDelay,
  retries: 2,
});

AccountApi.interceptors.response.use(
  (response) => response,
  (error) => {
    errorNotifier(error);
  },
);

SafeAccountApi.interceptors.response.use(
  (response) => response,
  (error) => errorNotifier(error, true),
);

export default AccountApi;
